
/* @ngInject */
export default function commonDataFactory($http, $q, HPConfig) {
    return {
        getStates,
    };


    function getStates(excludeInactive) {
        const data = excludeInactive || false;
        return $http({
            url: `${HPConfig.heroProApi}Address/States?excludeInactive=${data}`,
            method: 'GET',
        });
    }
}




// WEBPACK FOOTER //
// ./src/app/common/dataFactories/commonDataFactory.js